<nav class="subnav">
  <ul class="nav">
    <li class="nav-item">
      <a class="nav-link active" [routerLink]="['/component/overview/true']">Zur Übersicht</a>
    </li>
  </ul>
</nav>
<main>
  <h2>PHM PPS  <cds-icon shape="two-way-arrows"></cds-icon>  Komponente bearbeiten</h2>
  <p class="opener" cds-text="section">Komponenten können einfache Bauteile, Normteile, technologische Verfahren oder ganze Baugruppen sein. <br>Nach Eingabe können Komponenten auch zu Baugruppen zussammengefügt werden.</p><br>

  <app-component-form
    [isUpdateMode]="true"
    [componentData]="componentData"
    (formSubmit)="onComponentUpdated($event)">
  </app-component-form>

  <pre *ngIf="devMode">componentData: {{ componentData | json }}</pre>
</main>
